<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<!-- <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button> -->
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="设备号" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.device_id }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.status === 1" size="mini" type="success">正常</el-tag>
					<el-tag v-if="scope.row.status === 2" size="mini" type="danger">停用</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="连接时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.utime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center" fixed="right">
				  <template slot-scope="scope">
			<!-- 		<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip> -->
					<el-tooltip class="item" effect="dark" content="日志" placement="top">
					  <el-button type="warning" icon="el-icon-tickets" size="mini" circle @click="handlelist(scope.row.id)"></el-button>		
					</el-tooltip>
		<!-- 			<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip> -->
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 编辑-->
		<el-dialog :visible.sync="open" width="600px" :close-on-click-modal="false" append-to-body :title="title">
		  <el-form ref="form" :model="form" :rules="rules" label-width="80px" size="small">
		    <el-form-item label="名称" prop="username">
		      <el-input v-model="form.username" placeholder="请输入名称" type="text" clearable />
		    </el-form-item>
		    <el-form-item label="密码" prop="password">
		      <el-input v-model="form.password" placeholder="请输入密码" type="password" clearable />
		    </el-form-item>
		    <el-form-item label="电话" prop="mobile">
		      <el-input v-model="form.mobile" placeholder="请输入电话" type="text" clearable />
		    </el-form-item>
		   <el-form-item  label="状态">
		      <el-radio-group v-model="form.status">
		      	<el-radio :label="1">使用</el-radio>
		      	<el-radio :label="2">停用</el-radio>
		      </el-radio-group>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="cancel">取 消</el-button>
		    <el-button type="primary" size="mini" @click="handleSubmit">确 定</el-button>
		  </div>
		</el-dialog>
		<!-- 日志列表 -->
		 <el-dialog
			 :visible.sync="record_open"
			 width="950px"
			 :close-on-click-modal="false"
			 append-to-body
			 title="日志"
		   >
			 <el-table
			   v-loading="listLoading"
			   size="small"
			   :data="recordList"
			   element-loading-text="Loading"
			   highlight-current-row
			   style="width: 100%"
			 >
			   <el-table-column label="ID" width="80" align="center">
				 <template slot-scope="scope">
				   {{ scope.row.id }}
				 </template>
			   </el-table-column>
			   <el-table-column label="描述" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.message }}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="设备号" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.device_id || 0}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="命令" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.command || 0}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column align="center" label="变更时间">
				 <template slot-scope="scope">
				   <span>{{ scope.row.ctime }}</span>
				 </template>
			   </el-table-column>
			 </el-table>
			 <pagination
			   :total="recordForm.total"
			   auto-scroll
			   :page.sync="recordForm.page"
			   :limit.sync="recordForm.limit"
			   @pagination="handlelist"
			 />
			 <div slot="footer" class="dialog-footer"></div>
		</el-dialog>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'dc',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				form:{
					username:'',
					password:'',
					mobile:'',
					role_ids:[],
					status:1,
					avatar:'',
					url:'',
				},
				rules:{
					username: [
					  { required: true, message: '请输入名称', trigger: 'blur' }
					],
					role_ids: [
					  { required: true, message: '请选择角色', trigger: ['blur', 'change'] }
					],
				},
				page: {
					page: 1,
					limit: 10,
					total:0,
					keyword: '',
				},
				record_open:false,
				recordList:[],
				listLoading: false,
				recordForm: {
					page: 1,
					limit: 10,
					total:0,
					name:'',
					id:'',
				},
			}
		},
		mounted() {
			
		},
		methods:{
			reset() {
			  this.form = {
			   username:'',
			   password:'',
			   mobile:'',
			   role_ids:[],
			   status:1,
			   avatar:'',
			   url:'',
			  }
			  this.resetForm('form')
			},
			handlelist(id){
				this.record_open = true;
				this.recordList = [];
				if(id){
				  this.recordForm.id = id
				}
				if(name.constructor !== Object){
					this.recordForm.name = name
				}
				this.axios.get('/manage/dc/recordList',{
				  params:this.recordForm
				}).then(res=>{
				  if(res.status){
					 this.recordList = res.data.data
					 this.recordForm.total = res.data.total
				  }
				})
			},
		}
	}
</script>

<style>
</style>